import Model from '@/Models/Model';

export default class Pagination extends Model {}
